<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-layout md-alignment-top-right">
        <router-link :to="{ path: '/config/edit' }">
          <md-button class="md-info">Edit</md-button>
        </router-link>
        <router-link :to="{ path: '/config/history' }" style="padding-left: 1em">
          <md-button class="md-info">History</md-button>
        </router-link>
      </div>

      <ApolloQuery :query="configQuery" :notifyOnNetworkStatusChange="true">
        <template v-slot="{ result: { loading, data, fullData } }">
          <div v-if="loading" class="loading apollo">
            Loading...
          </div>
          <div v-else-if="data && data.config">
            <config-card :config="data.config" :readonly="true">
              <template v-slot:title>
                <h4 class="title">Current Config</h4>
              </template>
            </config-card>
            <div class="md-layout-item" style="text-align: right">
              Configured {{ data.config.createdAt | moment }}
            </div>
          </div>
          <div v-else-if="fullData.errors.some(noConfigFound)">
            <config-card :config="{}" :readonly="true">
              <template v-slot:title>
                <h4 class="title">Current Config</h4>
              </template>
            </config-card>
          </div>
          <div v-else class="error apollo">
            An error occurred while retrieving config
            <ul>
              <li v-for="error in fullData.errors" :key="error.path.join(':')" class="md-layout-item">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </template>
      </ApolloQuery>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ConfigCard from "@/components/Cards/Config/ConfigCard";
import { ConfigQuery } from "@/graphql.js";

export default {
  name: "Config",
  components: {
    ConfigCard,
  },
  methods: {
    configQuery() {
      return ConfigQuery;
    },
    noConfigFound(error) {
      return error.extensions && error.extensions.code === "GONE";
    },
  },
  filters: {
    moment(datetime) {
      return moment(datetime).utc().format('YYYY-MM-DD hh:mm A UTC');
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
